
if ($("#verification").length) {
    $('#verification input[name="state"]').mask("AA");
    $('#verification input[name="zip"]').mask("00000");
    $("#dob_date").mask("00/00/0000");
    $('#verification input[name="ssn"]').mask("0000");
    $("#verification").validate({
        rules: {
            fname: {
                required: true
            },
            lname: {
                required: true
            },
            address: {
                required: true
            },
            city: {
                required: true
            },
            state: {
                required: true
            },
            zip: {
                required: true,
                number: true,
                rangelength: [5, 5]
            },
            dob: {
                required: true,
                rangelength: [10, 10]
            },
            ssn: {
                number: true,
                rangelength: [4, 4]
            }
        },
        submitHandler: function (_, event) {
            event.preventDefault();
            if (!document.querySelector(".loading-verify-form")) {
                $("#verification").prepend('<p class="loading-verify-form" style="margin-top:20px;">Working...</p>');
            } else {
                $('.loading-verify-form').show();
            }

            // Disable Button
            $('#verification button').prop("disabled", true).css({
                "opacity": "0.5",
                "cursor": "default"
            });

            // Format Date Error
            if (!validateDateFormat($("#dob_date").val())) {
                $('#verification button').prop("disabled", false).css({
                    "opacity": "1",
                    "cursor": "pointer"
                });
                $(".veratad-message").addClass("error").html("<ul><li>" + "The DOB format should be MM/DD/YYYY make sure you are entering it correctly." + '</li></ul>').fadeIn(300)
                return;
            }

            // Check Age
            let date = new Date($("#dob_date").val())
            if (getYearDifference(date) < 21) {
                $('#verification button').prop("disabled", false).css({
                    "opacity": "1",
                    "cursor": "pointer"
                });
                $(".veratad-message").addClass("error").html("<ul><li>" + "Underage Match Detected. Black Buffalo is intended for 21+ users of tobacco, nicotine, and comparable products. Please exit the site immediately." + '</li></ul>').fadeIn(300)
                return;
            }

            // Convert Date Format
            $('#verification input[name="dob"]').val(convertDateFormat($("#dob_date").val()));
            let form_data = $("#verification").serialize();

            $.ajax({
                type: "POST",
                crossDomain: true,
                headers: {
                    'Access-Control-Allow-Origin': '*'
                },
                url: "https://verification.blackbuffalo.com" + "/form-submit",
                data: form_data,
                async: true,
                success: (data) => {
                    verifyAge(data);
                    (function () {
                        window.artsai_tag.event("misc");
                    })();
                },
                error: (XHR, textStatus, errorThrown) => {
                    $('.loading-verify-form').hide();
                    console.log("textStatus-> " + textStatus);
                    console.log("error-> " + errorThrown);
                    $(".veratad-message").addClass("error").html('FAIL<ul><li>Please reach out to the Dip Angels via chat or email at <a href="mailto: info@blackbuffalo.com">info@blackbuffalo.com</a> for assistance.</li></ul>').fadeIn(300);
                }
            });
        }
    })
}

function validateDateFormat(date) {
    // Regular expression for MM/DD/YYYY format
    var pattern = /^\d{2}\/\d{2}\/\d{4}$/;
    return pattern.test(date);
}

function getYearDifference(date) {
    // Get the current date
    var currentDate = new Date();
    // Convert the date in MM/DD/YYYY format to a Date object
    var specificDate = new Date(date);
    // Calculate the difference in milliseconds
    var differenceInMilliseconds = currentDate - specificDate;
    // Convert the difference from milliseconds to years
    var differenceInYears = differenceInMilliseconds / (1000 * 60 * 60 * 24 * 365.25);
    return differenceInYears;
}

function convertDateFormat(date) {
    // Split the date into month, day, and year
    var parts = date.split("/");
    // Reconstruct the date in the YYYY/MM/DD format
    var newDate = parts[2] + "/" + parts[0] + "/" + parts[1];
    return newDate;
}

function tagVerified(data, customer_id) {
    if (data.updated) {
        if (customer_id == cID) {
            $("#verification").html('<p class="success">Success! We were able to successfully verify your age. If you were in the middle of checking out, <a href="/checkout">please continue</a>!</p>').fadeIn(300);
        } else {
            $("#verification").html('<p class="error">There was an error updating your customer data. Please contact a site administrator.</p>').fadeIn(300);
        }
    } else {
        $("#verification").html('<p class="error">There was an error updating your customer data. Please contact a site administrator.</p>').fadeIn(300);
    }
    setTimeout(function () {
        window.location.reload();
    }, 5000);
}

function verifyAge(data) {
    let hideError = true;
    if (!data.inserted) {
        $('#verification button').prop("disabled", false).css({
            "opacity": "1",
            "cursor": "pointer"
        });
        $(".veratad-message").addClass("error").html("<ul><li>" + "FAIL, NO MATCH" + '</li><li>It seems some of the inserted information was incorrect. Could you please try again while double-checking that all information is correct, especially the "last 4 digits of SSN"</li>' + '<li>Please reach out to the Dip Angels via chat or email at <a href="mailto: info@blackbuffalo.com">info@blackbuffalo.com</a> for assistance.</li></ul>').fadeIn(300);
    } else {
        if (data.result.action == "PASS") {
            hideError = false;
            $.ajax({
                type: "POST",
                crossDomain: true,
                headers: {
                    'Access-Control-Allow-Origin': '*'
                },
                url: "https://verification.blackbuffalo.com" + "/tag-verified",
                data: {
                    cid: data.cid
                },
                async: true,
                success: (dataSuccess) => {
                    tagVerified(dataSuccess, data.cid);
                },
                error: (XHR, textStatus, errorThrown) => {
                    console.log("textStatus-> " + textStatus);
                    console.log("error-> " + errorThrown);
                    $(".veratad-message").addClass("error").html('<ul><li>Please reach out to the Dip Angels via chat or email at <a href="mailto: info@blackbuffalo.com">info@blackbuffalo.com</a> for assistance.</li></ul>').fadeIn(300);
                }
            });
        } else {
            $('#verification button').prop("disabled", false).css({
                "opacity": "1",
                "cursor": "pointer"
            });
            $(".veratad-message").addClass("error").html("<ul><li>" + data.result.action + ", " + data.result.detail + '</li><li>It seems some of the inserted information was incorrect. Could you please try again while double-checking that all information is correct, especially the "last 4 digits of SSN"</li>' + '<li>Please reach out to the Dip Angels via chat or email at <a href="mailto: info@blackbuffalo.com">info@blackbuffalo.com</a> for assistance.</li></ul>').fadeIn(300);
        }
    }
    $('.loading-verify-form').hide();
    if (hideError) {
        $("#verification").submit(function (event) {
            event.preventDefault();
            $(".veratad-message").removeClass("error").fadeOut(300);
        });
    }
}

